const AUTH_SIGNIN_ENTRY_KEY = "onboarding_analytics:auth_signin_entry";

/**
 * 登录发起口。
 *
 * - `carousel_primary`：Intro 轮播底部主按钮（Continue with Apple/Google）直登
 * - `signin_page`：独立登录页 `/login` 的 Sign in 表单
 * - `login_modal`：全站任意位置弹出的登录弹窗（`LoginModalProvider`）—— 与前两者
 *   **不共用页面**，成功率差别很大，混算会把弹窗的高流失摊薄进登录页
 * - `login_popup`：`screens/Login_Popup` 的 iframe 登录页 —— 它不是弹窗也不是主登录页，
 *   混进 `login_modal` 会让弹窗的成功率被一条完全不同的链路污染
 */
export type AuthSigninEntry =
  "carousel_primary" | "signin_page" | "login_modal" | "login_popup";
/** twitter 在弹窗 UI 里当前不可达（`SOCIAL_ICONS` 只有 Apple/Google），但 provider 层支持 ——
 *  留在值域里，真发生时如实上报，好过静默丢一条成功。 */
export type AuthSigninMethod = "apple" | "google" | "email" | "twitter";
export type AuthSigninPlatform = "ios" | "android" | "pc";

function isAuthSigninEntry(raw: string | null): raw is AuthSigninEntry {
  return (
    raw === "carousel_primary" ||
    raw === "signin_page" ||
    raw === "login_modal" ||
    raw === "login_popup"
  );
}

export function setAuthSigninEntry(entry: AuthSigninEntry): void {
  if (typeof window === "undefined") {
    return;
  }
  sessionStorage.setItem(AUTH_SIGNIN_ENTRY_KEY, entry);
}

export function consumeAuthSigninEntry(
  fallback: AuthSigninEntry = "signin_page",
): AuthSigninEntry {
  if (typeof window === "undefined") {
    return fallback;
  }
  const raw = sessionStorage.getItem(AUTH_SIGNIN_ENTRY_KEY);
  sessionStorage.removeItem(AUTH_SIGNIN_ENTRY_KEY);
  if (isAuthSigninEntry(raw)) {
    return raw;
  }
  return fallback;
}

export function peekAuthSigninEntry(): AuthSigninEntry | null {
  if (typeof window === "undefined") {
    return null;
  }
  const raw = sessionStorage.getItem(AUTH_SIGNIN_ENTRY_KEY);
  return isAuthSigninEntry(raw) ? raw : null;
}
